'use strict'

var $ = require('jquery');
var UnitConversion = require('../lib/UnitConversion.js');
var Debouncer = require('../lib/Debouncer.js');
var Colorbox = require('jquery-colorbox');

function Carousel(config) {
	this.config = $.extend({}, {
		component: 'carousel',
		trigger: ['carousel__link'],
		item: 'carousel__image',
		itemWrapper: 'wrapper',
		activeClassModifier: 'active',
		previousClassModifier: 'previous',
		nextClassModifier: 'next',
		startActive: 0,
		firstLastRecipients: [],
		firstLastInViewRecipients: [],
		centerElements: [],
		newHeightScale: 1,
		carouselSpeed: 4000,
		pauseOnScrollTimeout: 500,
		doAutoAdvance: true,
		doPopup: true,
		doPreviousClass: false,
		doReverseAnimation: false,
		doVariableHeight: false,
		doLoop: true,
		callbacks: {}
	}, config);

	this.$carousel = $('.' + this.config.component);

	if (this.$carousel.length == 0) return;

	var that = this;
	// Configure misc. classes classes
	if (this.config.itemActiveClass === undefined) {
		this.config.itemActiveClass = this.config.item + '--' + this.config.activeClassModifier;
	}
	if (this.config.itemWrapperClass === undefined) {
		this.config.itemWrapperClass = this.config.component + '__' + this.config.itemWrapper;
	}
	if (this.config.triggerActiveClass === undefined) {
		this.config.triggerActiveClass = this.config.trigger.map(function(element) {
			return element + '--' + that.config.activeClassModifier;
		});
	}
	if (this.config.doPreviousClass && this.config.itemPreviousClass === undefined) {
		this.config.itemPreviousClass = this.config.item + '--' + this.config.previousClassModifier;
	}
	if (this.config.doPreviousClass && this.config.componentPreviousTriggerClass === undefined) {
		this.config.componentPreviousTriggerClass = this.config.component + '--' + this.config.previousClassModifier;
	}
	if (this.config.componentNextTriggerClass === undefined) {
		this.config.componentNextTriggerClass = this.config.component + '--' + this.config.nextClassModifier;
	}
	if (this.config.doReverseAnimation && this.config.itemActiveRewindClass === undefined) {
		this.config.itemActiveRewindClass = this.config.item + '--' + this.config.activeClassModifier + 'Rewind';
	}
	if (this.config.doReverseAnimation && this.config.itemPreviousRewindClass === undefined) {
		this.config.itemPreviousRewindClass = this.config.item + '--' + this.config.previousClassModifier + 'Rewind';
	}

	this.timeoutId;

	this.$carouselPrevTrigger = $('.' + this.config.componentPreviousTriggerClass);
	this.$carouselNextTrigger = $('.' + this.config.componentNextTriggerClass);
	this.$carouselItem = $('.' + this.config.item);
	this.$carouselItemWrapper = $('.' + this.config.itemWrapperClass);
	this.$activeSlide = $('.' + this.config.itemActiveClass);

	this.info = {
		currentSlide: this.config.startActive,
		slideCount: this.$carouselItem.length
	};
}


/**
 * Match slide to selected trigger
 * @param  {number} triggerIndex The index of the slide to switch to
 */
Carousel.prototype.changeSlide = function(triggerIndex) {
	var that = this;
	this.$activeSlide = this.$carouselItem.eq(triggerIndex);
	var activeTriggers = that.config.trigger.map(function(element, index) {
		return $('.' + element).eq(triggerIndex);
	});
	var oldSlide = this.info.currentSlide;
	var $oldSlide = this.$carouselItem.eq(this.info.currentSlide);
	var isAdvancing = triggerIndex > this.info.currentSlide;

	// Update currentSlide
	this.info.currentSlide = triggerIndex;

	// Remove current active classes
	for (var i = 0; i < this.config.triggerActiveClass.length; i++) {
		$('.' + this.config.triggerActiveClass[i]).removeClass(this.config.triggerActiveClass[i]);
	}
	$('.' + this.config.itemActiveClass).removeClass(this.config.itemActiveClass);

	// Remove current rewind classes
	if (this.config.doReverseAnimation) {
		this.$carouselItem.removeClass(this.config.itemActiveRewindClass);
		this.$activeSlide.removeClass(this.config.itemPreviousRewindClass);

		// Apply rewind classes to new and previous
		if (!isAdvancing) {
			this.$activeSlide.addClass(this.config.itemActiveRewindClass);
			$oldSlide.addClass(this.config.itemPreviousRewindClass);
		}
	}

	// Add active class to triggers
	for (var i = 0; i < activeTriggers.length; i++) {
		activeTriggers[i].addClass(this.config.triggerActiveClass[i]);
	}

	// Center specified active element
	this.centerElement(triggerIndex);

	// Add active class to item
	this.$activeSlide.addClass(this.config.itemActiveClass);
	if (this.config.doPreviousClass) {
		this.$activeSlide.removeClass(this.config.itemPreviousClass);
	}

	// Add active class to wrapper
	if (oldSlide === null) {
		$('.' + this.config.itemWrapperClass).addClass(that.config.itemWrapperClass + '--active');
	}

	// Grow/shrink itemWrapper as appropriate
	if (this.config.doVariableHeight) {
		this.setVariableTimelineHeight(this.$activeSlide);
	}

	// Add first/last class to parent
	if (this.config.firstLastRecipients.length) {
		if (this.info.currentSlide === 0) {
			this.config.firstLastRecipients.forEach(function(element) {
				$('.' + element).addClass('first');
				$('.last', that.$component).removeClass('last');
			});
		} else if (this.info.currentSlide === this.info.slideCount - 1) {
			this.config.firstLastRecipients.forEach(function(element) {
				$('.' + element).addClass('last');
				$('.first', that.$component).removeClass('first');
			});
		} else {
			this.config.firstLastRecipients.forEach(function(element) {
				$('.first', that.$component).removeClass('first');
				$('.last', that.$component).removeClass('last');
			});
		}
	}

	// Run next/previous callbacks
	if (typeof this.config.callbacks.next === 'function' && isAdvancing) {
		this.config.callbacks.next();
	}
	if (typeof this.config.callbacks.previous === 'function' && !isAdvancing) {
		this.config.callbacks.previous();
	}
	if (typeof this.config.callbacks.change === 'function') {
		this.config.callbacks.change()
	}

	// Add/remove .previous class
	if (this.config.doPreviousClass) {
		$oldSlide.addClass(this.config.itemPreviousClass);
	}

	// Restart autoAdvance
	if (this.config.doAutoAdvance) {
		this.startCarousel();
	}

	this.config.callbacks.setActiveCollageImage.call(this);
	this.config.callbacks.changeBackground.call(this, triggerIndex);

	// Remove lightbox containing previous slide's images and initialize new lightbox
	$.colorbox.remove();
	this.initLightbox();
}

// Get index of next and pass to changeSlide()
Carousel.prototype.toNextSlide = function() {
	var isLast = (this.info.currentSlide >= this.info.slideCount - 1);

	// Exit if no loop and is last
	if (!this.config.doLoop && isLast) return;

	// Loop to first if last, else next
	var next = isLast
		? 0
		: this.info.currentSlide + 1;

	this.changeSlide(next);
}

// Get index of previous and pass to changeSlide()
Carousel.prototype.toPreviousSlide = function() {
	var isFirst = (this.info.currentSlide === 0);

	// Exit if no loop and is first
	if (!this.config.doLoop && isFirst) return;

	// Loop to last if first, else previous
	var previous = isFirst
		? this.info.slideCount - 1
		: this.info.currentSlide - 1;
	this.changeSlide(previous);
}

// Centers an element in a scrollable div
Carousel.prototype.centerElement = function(triggerIndex) {
	var that = this;
	for (var i = 0; i < this.config.centerElements.length; i++) {
		var $element = $('.' + this.config.centerElements[i]);
		var $elementParent = $element.parent();

		var elementParentWidth = $elementParent.width();

		var elementParentCenter = elementParentWidth / 2;

		var selectedElement = $element.get(triggerIndex);
		var left = selectedElement.offsetLeft + (selectedElement.clientWidth / 2) - elementParentCenter;

		$elementParent.animate({scrollLeft: left}, {
			duration: 350
		});
	}
}

// Stop autoAdvance
Carousel.prototype.stopCarousel = function(timeoutId) {
	var that = this;
	var timeoutId = timeoutId || that.timeoutId;
	window.clearTimeout(timeoutId);
}

// Start autoAdvance
Carousel.prototype.startCarousel = function() {
	var that = this;
	if (that.config.doAutoAdvance) {
		that.timeoutId = window.setTimeout(function() {
			that.toNextSlide();
		}, that.config.carouselSpeed);
	}
}

// Pause the carousel while scrolling
Carousel.prototype.autoAdvanceScrollPause = function() {
	if (this.config.doAutoAdvance) {
		var that = this;
		var startBackUpTimeout = undefined;
		$(window).on('scroll', function() {
			if (startBackUpTimeout === undefined) {
				that.stopCarousel(that.timeoutId);
			} else {
				window.clearTimeout(startBackUpTimeout);
			}
			startBackUpTimeout = setTimeout(function() {
				that.startCarousel();
				startBackUpTimeout = undefined;
			}, that.config.pauseOnScrollTimeout);
		})
	}
}

// Enable image lightbox on items
Carousel.prototype.initLightbox = function() {
	if (this.config.doPopup) {
		$('.timelineSlide--active .timelineSlide__imageWrap').colorbox({
			transition: 'elastic',
			initialWidth: '200',
			initialHeight: '200',
			width: '100%',
			height: '100%',
			maxWidth: '1000',
			maxHeight: '1000',
			fixed: true,
			close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 16.84">\
					<path fill="#fff" d="M13.46 15.34l1.48-1.49 15.35 15.34-1.49 1.49z" transform="translate(-12.96 -13.85)"/>\
					<path fill="#fff" d="M13 29.2l15.31-15.34 1.48 1.48-15.34 15.35z" transform="translate(-12.96 -13.85)"/>\
				</svg><span>Close</span>',
			previous: '\
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.29">\
					<path fill="#fff" d="M332.57 47.43a19.69 19.69 0 01-5.72 13.14L102.28 285.14l224.57 224.57a18 18 0 010 26.29l-28.57 28.57a18 18 0 01-26.28 0L5.71 298.29a18 18 0 010-26.29L272 5.71a18 18 0 0126.28 0l28.57 28.57a18.61 18.61 0 015.72 13.15z"/>\
				</svg>\
				<span>prev</span>',
			next: '\
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.28">\
					<path fill="#fff" d="M332.57 285.14a19.75 19.75 0 01-5.71 13.15L60.57 564.57a19.69 19.69 0 01-13.14 5.72 19.71 19.71 0 01-13.15-5.72L5.71 536A18.59 18.59 0 010 522.86a19.72 19.72 0 015.71-13.14l224.57-224.57L5.71 60.57a18 18 0 010-26.28L34.28 5.72A19.71 19.71 0 0147.43 0a19.69 19.69 0 0113.14 5.72L326.86 272a19.73 19.73 0 015.71 13.15z" />\
				</svg>\
				<span>next</span>',
			title: function() {
				return this.querySelector('img.timelineSlide__image--bottomLayer').getAttribute('title');
			},
			onOpen: function() {
				document.querySelector('html').classList.add('lockScroll');
			},
			onClosed: function() {
				document.querySelector('html').classList.remove('lockScroll');
			}
		});
	}
}

Carousel.prototype.setFixedFrameHeight = function() {
	var tallestSlideHeight = 0;
	
	this.$carouselItem.each(function() {
		var slideHeight = this.clientHeight;

		if (slideHeight > tallestSlideHeight) {
			tallestSlideHeight = slideHeight;
		}
	});

	// Set all slides to be the height of the tallest one, so that each slide's text is vertically centered properly
	this.$carouselItem.each(function() {
		this.style.height = tallestSlideHeight + 'px'; 
	});

	// Set the frame to be the height of the tallest slide
	this.$carouselItemWrapper[0].style.height = tallestSlideHeight + 'px';
}
Carousel.prototype.setFixedTimelineHeight = function() {
	if (this.config.doFixedHeight) {
		var that = this;

		that.setFixedFrameHeight();
		
		var resizeDebouncer = new Debouncer(function(){
			that.$carouselItem.each(function() {
				this.style.height = 'auto';
			});
			that.setFixedFrameHeight();
		});
		$(window).on('resize', resizeDebouncer.run);
	}
}

// Animate transition
// Grow to exact new height
Carousel.prototype.setVariableTimelineHeight = function($activeSlide) {
	if (this.config.doVariableHeight) {
		var that = this;
		var oldHeight = this.$carouselItemWrapper.outerHeight();
		var newHeight;

		if (this.itemHeightObject === undefined) {
			newHeight = this.$activeSlide.outerHeight();
		} else {
			newHeight = this.$activeSlide.find('.' + this.itemHeightObject).outHeight();
		}

		// newHeight = (newHeight / this.config.newHeightScale) + this.info.wrapperPadding;

		// Only animate if difference is greater than set amount
		if (Math.abs(newHeight - oldHeight) > 10) {
			this.$carouselItemWrapper.stop().animate({height: newHeight,overflow: 'visible'}, {duration: 350,easing: 'linear'});
		}
	}
}

// Initializes default handlers
Carousel.prototype.initHandlers = function() {
	var that = this;

	// Handler: Activate clicked trigger/slide pair
	that.config.trigger.forEach(function(element, index) {
		$('.' + element).on('click', function(event) {
			event.preventDefault();
			for (var i = 0; i < that.config.triggerActiveClass.length; i++) {
				if ($(event.target).hasClass(that.config.triggerActiveClass[index][i])) {
					return;
				}
			}

			var triggerIndex = $(this).index('.' + element);

			if (that.config.doAutoAdvance) {
				that.stopCarousel(that.timeoutId);
			}

			that.changeSlide(triggerIndex);
		});
	});

	// Handler: Change to previous slide on click of previous trigger
	this.$carouselPrevTrigger.on('click', function(event) {
		that.toPreviousSlide();
	});

	// Handler: Change to next slide on click of next trigger
	this.$carouselNextTrigger.on('click', function(event) {
		that.toNextSlide();
	});
}

// Adds position first/last status class to specified elements
Carousel.prototype.initFirstLast = function() {
	if (this.info.currentSlide === 0 && this.config.firstLastRecipients.length){
		this.config.firstLastRecipients.forEach(function(element) {
			$('.' + element).addClass('first');
		});
	} else if (this.info.currentSlide === this.info.slideCount - 1 && this.config.firstLastRecipients.length) {
		this.config.firstLastRecipients.forEach(function(element) {
			$('.' + element).addClass('last');
		});
	}
}

// Get the info required for variable height slides
Carousel.prototype.initVariableHeight = function() {
	var unitConversion = new UnitConversion();
	if (this.config.doVariableHeight) {
		var that = this;
		this.info.wrapperPadding =
			unitConversion.parseUnit(that.$carouselItemWrapper.css('padding-top')).value +
			unitConversion.parseUnit(that.$carouselItemWrapper.css('padding-bottom')).value;
	}
}

// Activates the slide and triggers specified to start active
Carousel.prototype.initStartActive = function() {
	if (typeof this.config.startActive !== 'number') return;

	var that = this;
	
	this.config.trigger.forEach(function(element, index) {
		$('.' + element).eq(that.config.startActive)
				  .addClass(that.config.triggerActiveClass[index]);
	});
	this.$carouselItem.eq(that.config.startActive)
					  .addClass(this.config.itemActiveClass);

	$('.' + this.config.itemWrapperClass).addClass(that.config.itemWrapperClass + '--active');

	this.$activeSlide = this.$carouselItem.eq(that.config.startActive);

	this.initVariableHeight();
	this.setVariableTimelineHeight(this.$activeSlide);
	
	var resizeDebouncer = new Debouncer(function(){
		that.setVariableTimelineHeight(that.$activeSlide);
	});
	$(window).on('resize', resizeDebouncer.run);

	this.setFixedTimelineHeight();

	this.config.callbacks.setActiveCollageImage.call(this);
}

// Initializes default activation function
Carousel.prototype.activate = function() {
	if (this.$carousel.length == 0) return;

	this.initStartActive();
	this.initHandlers();
	this.startCarousel();
	this.initLightbox();
	this.initFirstLast();
}

module.exports = Carousel;
